<template>
  <div
    class="appoint-page"
  >
    <div class="contact-info">
      <template v-for="(item, index) in CONTACTS_INFO">
        <div
          :key="`appoint-${index}`"
          class="item flx-row-btw"
        >
          <div
            class="flx-row-str"
            style="width: 40%"
          >
            <span class="avatar">
              <van-image
                v-if="item.img"
                :src="item.img"
                :show-error="false"
                :show-loading="false"
                width="52px"
                fit="cover"
                class="icon"
              />
              <span
                v-else
                class="default flx-ctr"
              >
                <van-image
                  :src="require('@/imgs/icon/contact.png')"
                  :show-error="false"
                  :show-loading="false"
                  class="icon"
                  style="transform: scale(0.8)"
                />
              </span>
            </span>
            <span class="text flx-col-ctr">
              <span style="margin-bottom: 3px">{{ item.name }}</span>
              <span style="color: rgba(0,0,0,0.6);font-size: 11px;">{{ item.title }}</span>
            </span>
          </div>
          <span
            v-if="isNormalView"
            class="call-btn flx-ctr"
            @click="phoneCall(item.phone)"
          >
            <van-icon
              name="phone-o"
              style="margin: 3px 4px 0 0"
            />
            <span>呼叫</span>
          </span>
          <span
            v-else
            class="call-btn flx-ctr"
            @click="onShare(index)"
          >
            <van-icon
              name="share-o"
              style="margin: 3px 4px 0 0"
            />
            <span>分享</span>
          </span>
        </div>
        <div
          :key="index"
          class="split-line-w"
        />
      </template>
    </div>
    <!-- 分享提示 -->
    <van-overlay
      :show="showPop"
      @click="showPop = false"
    >
      <div
        class="wrapper flx-col-ctr"
      >
        <van-image
          class="abs-r"
          style="right: 24px;top: 1vh;"
          :src="require('@/imgs/share_arrow.png')"
          :show-error="false"
          :show-loading="false"
          width="156px"
        />
        <p
          style="margin-top: 240px;color: #fff"
        >
          点击左上角按钮，分享给朋友
        </p>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { CONTACTS_INFO } from '@/libs/config/app';
import { wexinShare } from '@/libs/util';
import { getWeChatSignature } from '@/libs/api';
import { Overlay } from 'vant';

export default {
  components: {
    [Overlay.name]: Overlay,
  },
  data() {
    return {
      CONTACTS_INFO,
      showPop: false,
      isNormalView: true, // 普通的视图
    };
  },
  created() {
  // 设置正确的初始路由
    setTimeout(() => {
      this.activeNav = this.$route.name;
    }, 10);
  },
  mounted() {
    const { share = '0' } = this.$route.query;
    if (share === '1') {
      this.isNormalView = false;
    }
  },
  methods: {
  // 打电话
    phoneCall(num) {
      const phoneUrl = `tel:${num}`;
      window.location.href = phoneUrl;
    },
    // 生成分享链接
    onShare(index) {
      this.showPop = true;
      // 请求微信配置参数接口（获取签名），由后台给接口给
      const url = window.location.href.split('#')[0];
      // 看后台请求接口是get/post
      getWeChatSignature({ url }).then((res) => {
        const {
          return_data: { signature, timestamp },
        } = res;
        // 微信加签
        const obj = {
          debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
          timestamp, // 必填，生成签名的时间戳
          signature, // 必填，签名
        };
        const shareData = {
          link: `${url}?si=${index}`,
          desc: 'VR带看',
        };
        // 引用
        wexinShare(obj, shareData);
      });
    },
  },
};
</script>

<style lang="less" scope>
.appoint-page {
  padding: 0 12px;
  .contact-info {
    width: 100%;
    overflow: hidden;
    font-size: 15px;
    .item {
      margin: 15px 0;
      .text {
        align-items: flex-start;
        margin-left: 18px;
      }
      .avatar {
        img {
          width: 52px;
          height: 52px;
          border-radius: 50%;
        }
        & .default {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background-color: #eff0f4;
        }
      }
    }
    .call-btn {
      width: 2rem;
      height: .8rem;
      color: #f4f4f4;
      border-radius: 50px;
      background-image: linear-gradient(to bottom, rgba(7, 193, 96, .8), rgba(7, 193, 96, 1));
    }
  }
}
</style>
